import React from "react";
import ActionButton from "./Button";
import session from "../../assets/session.png";
import { useSelector } from "react-redux";


const SessionTimeout = (props) => {
  const roleId = useSelector((store) => store?.auth?.user?.role_id);

  const handleSubmit = () => {
    roleId === 1 ? props.Redirectpath("/admin") : props.Redirectpath("/Login");
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img src={session}></img>
      <div style={{ margin: "20px 0px" }}>
        <h1 style={{ textAlign: "center" }}>OOPS...!</h1>
        <p>Your session has expired. Please Login Again</p>
      </div>
      <ActionButton
        buttonText="Go To Login Page"
        backgroundColor="#FE9003"
        handleSubmit={handleSubmit}
      />
    </div>
  );
};

export default SessionTimeout;
